<template>
  <div
    v-if="$route.name === 'my assets'"
    class="briefcase"
  >
    <AuBreadcrumb
      :parent-name="$t('router.pages.dashboard')"
    />
    <div class="briefcase-button">
      <AuButton
        type="primary"
        center
        width="200px"
        @click="goToTopUp"
      >
        {{ $t("briefcase.buy") }}
      </AuButton>

      <AuButton
        v-if="showExchangeButton"
        bordered
        center
        width="200px"
        @click="goToConvert"
      >
        {{ $t("briefcase.convert") }}
      </AuButton>

      <AuButton
        bordered
        center
        width="200px"
        @click="goToWithdraw"
      >
        {{ $t("briefcase.withdraw") }}
      </AuButton>
    </div>

    <AuTabView
      resizable
      :active-tab="selectedTitle"
      @change="handleTabChange"
    >
      <!-- Вкладка с криптоактивами -->
      <AuTabPanel :title="$t('briefcase.cryptoTabLabel')">
        <UTable
          class="briefcase-table briefcase-table-hiddable"
          :items="itemsCrypto"
          :columns="cryptoTableColumns"
          :loading="loadingCrypto"
          :text-no-data="noDataText"
        >
          <!-- Слот для колонки с компанией/токеном -->
          <template #company="{ value, item }">
            <div
              :style="item.stype"
              class="link link-container"
              @click="toLink(value.link)"
            >
              <img
                :src="value.icon"
                class="icon-with-bg"
                alt=""
              >
              <div>
                <span class="link-text">
                  {{ value.name }}
                </span>
              </div>
            </div>
          </template>

          <!-- Слот для колонки с количеством токенов -->
          <template #tokensCount="{ value, item }">
            <AuDecimalStatic
              :style="item.stype"
              :value="value.value"
              :decimal="value.decimals"
              :show-addition="false"
            />
          </template>

          <!-- Слот для колонки с ценой токена -->
          <template #tokenCost="{ value, item }">
            <AuDecimalStatic
              :style="item.stype"
              :value="value.value"
              :indent="4"
              :show-addition="false"
            />
          </template>

          <template #tokenMnemonic="{ value, item }">
            <div :style="item.stype">
              {{ value }}
            </div>
          </template>

          <!-- Слот для колонки с суммой -->
          <template #tokenSum="{ value, item }">
            <div
              class="flex"
              :style="item.stype"
            >
              <AuDecimalStatic
                v-if="value.price == '1'"
                :value="value.valueRaw"
                :decimal="value.decimals"
                :indent="value.indent"
                :show-addition="false"
                :smart-indent="true"
              />
              <div v-else>
                {{ value.value }}
              </div>
              <div>
                <UTooltip
                  v-if="value.valueRaw && value.valueRaw !='-'"
                  :tooltip="'Here you can see funds which are requested for withdrawal.'"
                />
              </div>
            </div>
          </template>

          <!-- Слот для колонки с заблокированными токенами -->
          <template #tokenBlocked="{ value, item }">
            <div :style="item.stype">
              {{ value.value }}
            </div>
          </template>
        </UTable>

        <!-- Аккордеон для мобильной версии -->
        <div class="briefcase-accordion">
          <div v-if="itemsCrypto.length != 0">
            <AuAccordion
              v-for="(owner, index) in itemsCrypto"
              :key="owner.id"
              :last-child="(index == itemsCrypto.length - 1)"
            >
              <template #title>
                <span class="company-header">
                  <img
                    class="icon-with-bg"
                    :src="owner.company.icon"
                    :alt="owner.company.name"
                  >
                  {{ owner.company.name }}
                </span>
              </template>
              <template #content>
                <div class="company-info container-fluid">
                  <div
                    v-for="(column, cindex) in columnsCryptoAccordion"
                    :key="cindex"
                    class="row"
                  >
                    <div class="col company-info-title">
                      <span>
                        {{ column.name }}
                      </span>
                    </div>
                    <div class="col">
                      <div
                        v-if="column.decimal && column.property == 'tokenSum'"
                        class="mr"
                      >
                        <div v-if="owner[column.property].price == '1'">
                          <AuDecimalStatic
                            :value="owner[column.property].valueRaw"
                            :decimal="owner[column.property].decimals"
                            :indent="owner[column.property].indent"
                            :show-addition="false"
                            :smart-indent="true"
                          />
                        </div>
                        <div v-else>
                          {{ owner[column.property].value }}
                        </div>
                      </div>
                      <AuDecimalStatic
                        v-else-if="column.decimal && column.property == 'tokenCost'"
                        :value="owner[column.property].value"
                        :decimal="owner[column.property].decimals"
                        :indent="4"
                        :show-addition="false"
                      />
                      <AuDecimalStatic
                        v-else-if="column.decimal && column.property != 'tokenBlocked' && column.property != 'tokenCost' && column.property != 'tokenSum'"
                        :value="owner[column.property].value"
                        :decimal="owner[column.property].decimals"
                        :show-addition="false"
                      />
                      <div v-else-if="column.property == 'tokenBlocked'">
                        <div
                          class="link"
                          @click="toWithdrawTab"
                        >
                          <span class="link-text">
                            <AuDecimalStatic
                              :value="owner[column.property].value"
                              :decimal="owner[column.property].decimals"
                              :show-addition="false"
                            />
                          </span>
                          <AuTooltip
                            v-if="owner[column.property].value && owner[column.property].value !='-'"
                            class="briefcase-tooltip"
                            :description="'Here you can see funds which are requested for withdrawal.'"
                          />
                        </div>
                      </div>
                      <span v-else>{{ getPropertyValue(owner, column.property) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col buttons">
                      <AuButton
                        v-if="owner.company?.isDefault"
                        width="100%"
                        center
                        @click="topUp(index)"
                      >
                        {{ $t("briefcase.changeAction") }}
                      </AuButton>
                      <AuButton
                        v-if="owner.company?.isDefault"
                        width="100%"
                        center
                        @click="goToWithdraw"
                      >
                        {{ $t("briefcase.bringOutAction") }}
                      </AuButton>
                      <AuButton
                        v-if="isSendBtn"
                        width="100%"
                        center
                        @click="send(index)"
                      >
                        {{ $t("briefcase.sendAction") }}
                      </AuButton>
                    </div>
                  </div>
                </div>
              </template>
            </AuAccordion>
          </div>

          <ProgressLoader
            v-if="loadingCrypto"
            mode="indeterminate"
            color="#5AC396"
            size="150px"
          />

          <span v-else-if="itemsCrypto.length == 0">
            No assets yet
          </span>
        </div>

        <AuPagination
          v-if="ownerTotalItems > itemsPerPage"
          :hide="loadingCrypto || !itemsCrypto.length"
          :total-items="ownerTotalItems"
          @pageChanged="pageCryptoChanged"
        />
      </AuTabPanel>

      <!-- Вкладка с ордерами -->
      <AuTabPanel
        :title="$t('briefcase.ordersTabLabel')"
        :hidden="$auth.user().type == 'issuer'"
      >
        <Orders />
      </AuTabPanel>

      <!-- Вкладка со стекинг пулами -->
      <AuTabPanel
        :title="$t('briefcase.stackingPools')"
        :hidden="!hasAccessToStackingPool"
      >
        <StackingPools />
      </AuTabPanel>

      <!-- Вкладка с выводами средств -->
      <AuTabPanel :title="$t('briefcase.withdrawTabLabel')">
        <UTable
          class="briefcase-table briefcase-table-hiddable"
          :items="itemsWithdraw"
          :columns="withdrawTableColumns"
          :loading="dataLoading"
          :text-no-data="noDataText"
        >
          <!-- Слот для колонки с суммой -->
          <template #amount="{ value }">
            <AuDecimalStatic
              :value="value.value"
              :decimal="value.decimals"
              :show-addition="false"
            />
          </template>
        </UTable>

        <div class="briefcase-accordion">
          <div v-if="itemsWithdraw != 0">
            <AuAccordion
              v-for="(order, index) in itemsWithdraw"
              :key="order.id"
              :last-child="(index == itemsWithdraw.length - 1)"
            >
              <template #title>
                <span class="company-header">{{ order.createdAt }}</span>
              </template>
              <template #content>
                <div class="company-info container-fluid">
                  <div
                    v-for="(column, cindex) in withdrawAccordionColumns"
                    :key="cindex"
                    class="row"
                  >
                    <div class="col company-info-title">
                      <span>
                        {{ column.name }}
                      </span>
                    </div>
                    <div class="col">
                      <AuDecimalStatic
                        v-if="column.name == 'Sum'"
                        :value="order.amount.value"
                        :decimal="order.amount.decimals"
                        :show-addition="false"
                      />
                      <span v-else>{{ getPropertyValue(order, column.property) }}</span>
                    </div>
                  </div>
                </div>
              </template>
            </AuAccordion>
          </div>

          <ProgressLoader
            v-if="dataLoading"
            mode="indeterminate"
            color="#5AC396"
            size="150px"
          />

          <span v-else-if="itemsWithdraw.length == 0">
            No orders yet
          </span>
        </div>

        <AuPagination
          v-if="totalWithdraws > itemsPerPage"
          :hide="dataLoading || !itemsWithdraw.length"
          :total-items="totalWithdraws"
          @pageChanged="pageWithdrawChanged"
        />
      </AuTabPanel>

      <!-- Вкладка с Escrow Withdrawal -->
      <AuTabPanel
        :hidden="!isEscrowWD"
        :title="$t('briefcase.escrowWithdrawalTabLabel')"
      >
        <EscrowWithdrawal />
      </AuTabPanel>

      <!-- Вкладка с торговым балансом -->
      <AuTabPanel
        :hidden="!isTestRole"
        :title="$t('briefcase.tradeBalance')"
      >
        <Stock />
      </AuTabPanel>
    </AuTabView>
  </div>
  <RouterView
    v-else
    @update="updateData"
  />
</template>

<script>
import _ from "lodash";
import AuTabPanel from "@/components/extended/tabs/AuTabPanel";
import AuTabView from "@/components/extended/tabs/AuTabView";
import CurrencySupport from "@/help/currencySupport";
import EscrowWithdrawal from "@/panels/components/EscrowWithdrawal";
import isUserRole from "@/help/isUserRole";
import moment from "moment";
import Orders from "@/panels/components/Orders";
import ProgressLoader from "@/loaders/progress-bar";
import StackingPools from "@/panels/components/StackingPools";
import Stock from "@/panels/components/Stock.vue";
import UTable from "@/components/uikit/uComponents/UTable.vue";
import UTooltip from "@/components/uikit/uComponents/UTooltip.vue";
import { checkAccess, checkPostfix, scope } from "@/help/accessData";
import { formatDecimalStatic } from "../help/decimalStatic";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AuTabPanel,
    AuTabView,
    Orders,
    ProgressLoader,
    EscrowWithdrawal,
    StackingPools,
    Stock,
    UTable,
    UTooltip
  },
  data() {
    return {
      actionColumn: { label: "Операции", icon: "more" },
      currencySup: new CurrencySupport(),
      availableTokens: [],
      pageCrypto: 1,
      pageWithdraw: 1,
      itemsPerPage: 30,
      dataOwners: null,
      ownerTotalItems: 0,
      defaultToken: null,
      loadingCrypto: false,
      pageOrders: 1,
      pageVotes: 1,
      dataOrders: null,
      dataVotes: null,
      ordersTotalItems: null,
      votesTotalItems: null,
      selectedTitle: null
    };
  },

  computed: {
    ...mapGetters({
      language: "language",
      tokens: "tokens",
      tokensUtility: "tokensUtility",
      tokensFiat: "tokensFiat",
      exchangeBalances: "exchangeBalances",
      defaultTokenMnemonic: "defaultToken/defaultTokenMnemonic",
      defaultAutMnemonic: "defaultToken/defaultAutMnemonic",
      defaultTokenId: "defaultToken/defaultTokenId",
      withdraws: "withdrawal/withdraws",
      totalWithdraws: "withdrawal/totalWithdraws",
      dataLoading: "withdrawal/dataLoading",
      isTestRole: "profile/isTestRole",
      apiSystemSettings: "apiSystemSettings",
      arrEth: "ethAddresses"
    }),

    isNotRwa() {
      return checkAccess(scope.notRwa);
    },

    postfix() {
      return checkPostfix();
    },

    isSendBtn() {
      return this.apiSystemSettings?.enableUserSend == "true";
    },

    hasAccessToStackingPool() {
      return checkAccess(scope.stackingPool);
    },

    isEscrowWD() {
      return isUserRole() == "expert" || isUserRole() == "issuer";
    },

    address() {
      return _.get(this.arrEth, "[0]", "");
    },

    noDataText() {
      if (!this.address || !this.address?.verifiedAt || !this.address?.status) {
        return this.$t("briefcase.connectWallet");
      }
      else {
        return "";
      }
    },

    // Computed колонки для таблицы криптоактивов
    cryptoTableColumns() {
      const columns = [
        {
          property: "company",
          header: this.$t("briefcase.firstColumn"),
          align: "start"
        },
        {
          property: "tokensCount",
          header: this.$t("briefcase.secondColumn"),
          align: "center"
        },
        {
          property: "tokenMnemonic",
          header: this.$t("briefcase.thirdColumn"),
          align: "center"
        }
      ];

      if (!this.isNotRwa) {
        columns.push(
          {
            property: "tokenBlocked",
            header: this.$t("briefcase.fifthColumn"),
            align: "center"
          }
        );
      }
      else {
        columns.push(
          {
            property: "tokenBlocked",
            header: `${this.$t("briefcase.fourthColumn")} ${this.defaultTokenMnemonic}`,
            align: "center"
          },
          {
            property: "tokenCost",
            header: `${this.$t("briefcase.sumColumn")} ${this.defaultTokenMnemonic}`,
            align: "center"
          },
          {
            property: "tokenSum",
            header: this.$t("briefcase.fifthColumn"),
            align: "center"
          }
        );
      }

      // Добавляем колонку с действиями (контекстное меню)
      columns.push({
        property: "actions",
        header: this.$t("briefcase.actions"),
        align: "center",
        type: "menu",
        menuFunction: this.getCryptoMenuItems
      });

      return columns;
    },

    columnsCryptoAccordion() {
      if (!this.isNotRwa) {
        return [
          { name: this.$t("briefcase.secondColumn"), slot: "tokensCount", property: "tokensCount", decimal: true },
          { name: this.$t("briefcase.thirdColumn"), property: "tokenMnemonic" },
          { name: this.$t("briefcase.fifthColumn"), slot: "tokenBlocked", property: "tokenBlocked", decimal: true }
        ];
      }
      else {
        return [
          { name: this.$t("briefcase.secondColumn"), slot: "tokensCount", property: "tokensCount", decimal: true },
          { name: this.$t("briefcase.thirdColumn"), property: "tokenMnemonic" },
          { name: `${this.$t("briefcase.fourthColumn")} ${this.defaultTokenMnemonic}`, slot: "tokenCost", property: "tokenCost", decimal: true },
          { name: `${this.$t("briefcase.sumColumn")} ${this.defaultTokenMnemonic}`, slot: "tokenSum", property: "tokenSum", decimal: true },
          { name: this.$t("briefcase.fifthColumn"), slot: "tokenBlocked", property: "tokenBlocked", decimal: true }
        ];
      }
    },

    // Computed колонки для таблицы выводов
    withdrawTableColumns() {
      return [
        { property: "createdAt", header: this.$t("briefcase.dateColumn"), align: "start" },
        { property: "auToken", header: this.$t("briefcase.tokenColumn"), align: "center" },
        { property: "amount", header: this.$t("briefcase.sum2Column"), align: "center" },
        { property: "status", header: this.$t("briefcase.statusColumn"), align: "center" }
      ];
    },

    withdrawAccordionColumns() {
      return [
        { name: this.$t("briefcase.dateColumn"), property: "createdAt" },
        { name: this.$t("briefcase.tokenColumn"), property: "auToken" },
        { name: "Sum", property: "amount" },
        { name: this.$t("briefcase.statusColumn"), property: "status" }
      ];
    },

    itemsCrypto() {
      return _.map(this.dataOwners, (auOwner, index) => {
        const itemId = auOwner.auToken?.id || `item-${index}`;

        const item = {
          id: itemId,
          stype: this.getPropertyStyle(auOwner.amount),
          company: {
            icon: (auOwner.auToken?.logoMain ?? auOwner.auToken?.mainImage?.name) ?? "/svg/companies/s_logo.svg",
            link: auOwner.auToken.id,
            name: auOwner.auToken.nameEng,
            isDefault: auOwner.auToken.mnemonicEng == this.defaultTokenMnemonic ||
                auOwner.auToken.mnemonicEng == process.env.VUE_APP_AUT_MNEMONIC,
            showStockExchangeMenu: (_.findIndex(this.availableTokens, el => el.symbol === auOwner.auToken.mnemonicEng) !== -1) && this.isTestRole
          },
          tokensCount: {
            value: auOwner.amount,
            decimals: auOwner.auToken.decimals
          },
          tokenMnemonic: auOwner.auToken.mnemonicEng,
          tokenBlocked: {
            value: auOwner.amountBlocked == "0" ? "-" : formatDecimalStatic({ value: auOwner.amountBlocked, decimal: auOwner.auToken.decimals, price: auOwner.rateDefaultToken }),
            decimals: auOwner.auToken.decimals
          },
          // Добавляем данные для контекстного меню
          actionData: {
            index: index,
            id: auOwner.auToken.id,
            isDefault: auOwner.auToken.mnemonicEng == this.defaultTokenMnemonic ||
                auOwner.auToken.mnemonicEng == process.env.VUE_APP_AUT_MNEMONIC,
            showStockExchangeMenu: (_.findIndex(this.availableTokens, el => el.symbol === auOwner.auToken.mnemonicEng) !== -1) && this.isTestRole
          }
        };

        if (this.isNotRwa) {
          item.tokenCost = {
            value: auOwner?.rateDefaultToken || "-"
          };
          item.tokenSum = {
            value: formatDecimalStatic({ value: auOwner.amount, decimal: auOwner.auToken.decimals, price: auOwner?.rateDefaultToken }),
            valueRaw: auOwner.amount,
            indent: auOwner.auToken.indent,
            decimals: auOwner.auToken.decimals,
            price: auOwner?.rateDefaultToken
          };
        }
        return item;
      });
    },

    itemsWithdraw() {
      return _.map(this.withdraws, (item, index) => ({
        id: item.id || `withdraw-${index}`,
        createdAt: moment(item.createdAt).locale(this.language).format("DD MMM YYYY"),
        auToken: item?.token?.mnemonicEng,
        amount: {
          value: item.value,
          decimals: item?.token?.decimals
        },
        status: this.getStatus(item.isConfirmed) ?? "-"
      }));
    },

    showExchangeButton() {
      if (process.env.VUE_APP_DISABLE_EXCHANGE == "false") {
        return false;
      }
      else {
        return _.find(this.tokensUtility, token => token.mnemonicEng === this.defaultAutMnemonic);
      }
    }
  },

  watch: {
    "$route.query.tab": {
      handler(newTab) {
        this.handleTabChange(newTab);
      }
    },

    isTestRole: {
      async handler(newRole) {
        if (newRole && this.availableTokens.length === 0) {
          await this.getAvailableTokens();
        }
      }
    }
  },

  async mounted() {
    this.handleTabChange(this.$route.query?.tab);
    this.defaultToken = _.find(this.tokens, token => token.id == this.defaultTokenId);
    await this.getDataPage();
    await this.getWithdrawPage();
    if (this.isTestRole) {
      await this.getAvailableTokens();
    }
  },

  methods: {
    ...mapActions({
      getOwnerPage: "getOwnerPage",
      getAuOwnerByTokenId: "getAuOwnerByTokenId",
      getTradeTokens: "getTradeTokens",
      getWithdrawalRequests: "withdrawal/getWithdrawalRequests",
      getInvestmentsAuCapitals: "capitals/getInvestmentsAuCapitals"
    }),

    getPropertyStyle(tokensCount) {
      if (tokensCount == 0) {
        return {
          "color": "var(--color-60)",
          "--opacity": "50%"
        };
      }
    },

    // Функция для генерации пунктов контекстного меню криптоактивов
    getCryptoMenuItems(itemData) {
      const items = [];

      // Кнопка пополнения (для дефолтных токенов)
      if (itemData.actionData.isDefault) {
        items.push({
          label: this.$t(`briefcase.changeAction${this.postfix}`),
          command: () => {
            this.topUp(itemData.actionData.index);
          }
        });
      }

      // Кнопка вывода (для дефолтных токенов)
      if (itemData.actionData.isDefault) {
        items.push({
          label: this.$t("briefcase.bringOutAction"),
          command: () => {
            this.goToWithdraw();
          }
        });
      }

      // Кнопка отправки
      if (this.isSendBtn) {
        items.push({
          label: this.$t("briefcase.sendAction"),
          command: () => {
            this.send(itemData.actionData.index);
          }
        });
      }

      // Кнопка отправки на биржу (для тестеров)
      if (itemData.actionData.showStockExchangeMenu) {
        items.push({
          label: this.$t("briefcase.sendToExchange"),
          command: () => {
            this.goToStockExchange(itemData.index);
          }
        });
      }

      return [
        {
          items: items
        }
      ];
    },

    async updateData() {
      await this.getDataPage();
    },

    async handleTabChange(newTab) {
      await this.$nextTick();

      this.selectedTitle = newTab;
      if (newTab == this.$t("briefcase.cryptoTabLabel")) {
        this.$router.replace({
          query: { ...this.$route.query, tab: undefined }
        });
      }
      else {
        this.$router.replace({
          query: { ...this.$route.query, tab: newTab }
        });
      }
    },

    getPropertyValue(data, property) {
      return _.get(data, [property]);
    },

    toLink(link) {
      this.$router.push({ name: this.isNotRwa ? "token info" : "coin info", params: { id: link } });
    },

    toWithdrawTab() {
      this.selectedTitle = this.$t("briefcase.withdrawTabLabel");
      this.$router.replace({
        query: { ...this.$route.query, tab: this.selectedTitle }
      });
    },

    send(index) {
      this.$router.push({ name: "send token", params: { id: this.dataOwners[index].auToken.id } });
    },

    topUp() {
      this.goToTopUp();
    },

    goToTopUp() {
      if (!this.isNotRwa) {
        this.$router.push({ name: "card buy form" });
      }
      else {
        this.$router.push({ name: "buy form" });
      }
    },

    goToWithdraw() {
      if (!this.isNotRwa) {
        this.$router.push({ name: "card withdraw form" });
      }
      else {
        this.$router.push({ name: "withdraw" });
      }
    },

    goToConvert() {
      this.$router.push({ name: "convert token" });
    },

    goToStockExchange(index) {
      this.$router.push({ name: "stock deposit", params: { id: this.dataOwners[index].auToken.id } });
    },

    getStatus(status) {
      return status ? this.$t("briefcase.confirmed") : this.$t("briefcase.notConfirmed");
    },

    async getNonAssetBalances(owners) {
      const nonAsset = [];
      const unique = new Set();
      _.forEach([...this.tokensFiat, ...this.tokensUtility], item => unique.add(item));
      for (const token of unique.values()) {
        const resp = await this.getAuOwnerByTokenId({ tokenId: token.id, ownerAddress: this.arrEth[0].value });
        if (resp.length === 0) {
          nonAsset.push({ auToken: token, amount: 0, amountBlocked: 0 });
        }
      }
      return [...nonAsset, ...owners];
    },

    async getDataPage() {
      this.loadingCrypto = true;
      if (!this.arrEth[0]?.verifiedAt) {
        this.loadingCrypto = false;
        return;
      }
      try {
        const resp = await this.getOwnerPage({
          page: this.pageCrypto,
          itemsPerPage: this.itemsPerPage
        });
        const owners = this.pageCrypto === 1 ? await this.getNonAssetBalances(resp.data) : resp.data;
        const first = _.filter(owners, el => el.auToken.type === "utility" || el.auToken.type === "fiat");
        const other = _.reject(owners, el => el.auToken.type === "utility" || el.auToken.type === "fiat");
        this.dataOwners = [...first, ...other];
        this.ownerTotalItems = resp.totalItems;
      }
      catch (e) {
        this.$toast.error(this.$t("briefcase.error"));
      }
      this.loadingCrypto = false;
    },

    async getAvailableTokens() {
      try {
        const resp = await this.getTradeTokens();
        this.availableTokens = resp.data?.tokens;
      }
      catch (e) {
        console.error(e);
      }
    },

    async getWithdrawPage() {
      await this.getWithdrawalRequests({
        page: this.pageWithdraw,
        itemsPerPage: this.itemsPerPage,
        type: "token_withdrawal"
      });
    },

    async pageCryptoChanged(actualPage) {
      this.pageCrypto = actualPage;
      await this.getDataPage();
    },

    async pageWithdrawChanged(actualPage) {
      this.pageWithdraw = actualPage;
      await this.getWithdrawPage();
    }
  }
};
</script>

<style lang="scss">
.briefcase {
  .lv-progressbar {
    margin-top: 7px !important;
    margin-bottom: 7px !important;
  }
}
</style>

<style lang="scss" scoped>
.briefcase-main {
  padding: 20px;
}
.briefcase-button {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;

  @media screen and (max-width:590px) {
    gap: 10px;
  }

  @media screen and (max-width:400px) {
    flex-direction: column;

    >button {
      width: 100% !important;
    }
  }
}

.briefcase {
  &-info {
    padding: 11px 20px 0 18px;

    .title {
      font-weight: 600;
      font-size: 24px;
      color: var(--text-color);
      margin-bottom: 30px;
    }
  }

  &-table {
    margin-top: 10px;
    margin-bottom: 10px;

    &-hiddable {
      @media screen and (max-width:590px) {
        display: none;
      }
    }
  }

  &-accordion {
    display: none;

    @media screen and (max-width:590px) {
      display: block;
    }
  }
}

.spot-balance {
  color: var(--color-50);
  font-weight: 500;
  font-size: 12px;
}

.company {
  &-header {
    color: var(--text-color);
    font-size: 12px;
  }

  &-info {
    color: var(--text-color);
    display: flex;
    padding-right: 0;
    padding-left: 0;
    flex-direction: column;
    gap: 20px;

    &-title {
      color: var(--color-60)
    }

    .row {
      font-weight: 450;
      font-size: 12px;

      .col:last-child {
        text-align: end;
      }

      .buttons {
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }

}

.icon-with-bg {
  width: 25px;
  height: 25px;
  margin-right: 8px;
  opacity: var(--opacity);
}

.link-container {
  display: flex;
  align-items: center;
}

.link {
  &:hover {
    cursor: pointer;
  }
  .link-text {
    line-height: 1.1;
    &:hover {
      border-bottom: 1px dashed var(--color-00);
    }
  }
}
.briefcase-tooltip {
  margin-left: 2px;
}
.mr {
  margin-right: 4px;
}
.briefcase-table-hiddable {
  @media screen and (max-width:670px) {
    display: none;
  }
}
</style>